<form [formGroup]="form" (ngSubmit)="onSubmit(form)" errorTailor>
    <div class="form-group" [hidden]="hideLookup">
        <label for="lookupType" >Select {{lookupLabel}}</label>
        <select id="lookupType" class="form-select" formControlName="LookupType">
            <option [defaultSelected]=true value="0" disabled>Select One</option>
            <option *ngFor="let opt of lookupTypes" [ngValue]="opt.Value">{{opt.Label}}</option>
        </select>
    </div>

    <span class="edl-display-label" id="commentLabel">Comment</span>

    <quill-editor class="w-100" formControlName="Comment" [disabled]="isReadOnly()" (appFocusAutosave)="autosave(form)" edlQuillLabelledBy="commentLabel"></quill-editor>

    <div class="text-center">
        <span *ngIf="!form.valid || doesFormNeedSaved(form)" class="text-dark">Unsaved</span>
        <span *ngIf="form.valid && !doesFormNeedSaved(form)" class="text-success" role="status" aria-live="polite">Saved</span>
    </div>

    <ul class="list-group list-group-flush" *permissionsAll="[PermissionTypes.FILE_ATTACHMENTS]">
        <li class="list-group-item" *ngFor="let file of attachments; index as i">
            <paetep-attachment-button
                [attachment]="file"
                [shouldDisplayDate]="true"
                [canDeleteAttachment]="true"
                (onAttachmentDeleted)="onAttachmentDeleted(i)">
            </paetep-attachment-button>
        </li>
    </ul>
    <div class="d-flex flex-row justify-content-between">
        <div class="text-start">
            <ng-template [ngIf]="!isReadOnly()">
                <button type="button" class="btn btn-secondary m-2 attach-button" *permissionsAll="[PermissionTypes.FILE_ATTACHMENTS]"
                    (click)="onAttachComment()">+ Attach File</button>
            </ng-template>
        </div>
        <div class="text-end">
            <button type="button" class="btn btn-secondary m-2 save-button" [disabled]="!isFormValid()" *ngIf="!isReadOnly()"
                (click)="onSubmit(form)"><i class="far fa-save"></i> Save Comment</button>
            <button type="button" class="btn btn-primary m-2 publish-button" [disabled]="!isFormValid()"
                *ngIf="!isReadOnly() && (!comment || comment.commentState == CommentState.DRAFT)" (click)="onSubmit(form, true)"><i
                class="fas fa-plus"></i> Publish Comment</button>
            <button type="button" class="btn btn-info m-2 cancel-button" (click)="onCancelClicked()">Close</button>
        </div>

    </div>
</form>

